<template>
  <div class="container">
    <div class="how-it-works d-flex">
      <img src="./../assets/images/how-it-works/how.png" alt="" class="how-it-works__img">
      <div class="how-it-works__text-wrapper">
        <div class="how-it-works__title text-medium">Як потрапити на свято?
          Все просто!
        </div>
        <ol class="how-it-works__list">
          <li class="how-it-works__list-item position-relative">Введи прізвище та ім’я колеги, якого хочеш бачити на Гранд Пікніку.
            <br> Себе
            теж можна вибрати :)
          </li>
          <li class="how-it-works__list-item position-relative">Автоматично підтягнеться посада та підрозділ. Просто перевір, що це саме
            той колега
          </li>
          <li class="how-it-works__list-item position-relative">Постав від 1 до 5 балів за кожну номінацію. Цікаво дізнатись, у чому
            суперсила номінанта
          </li>
          <li class="how-it-works__list-item position-relative">Натисни кнопку <span class="text-medium">Хочу, щоб колега був на святі</span> Готово! Тепер тримай кулачки
            :)
          </li>
        </ol>
        <div class="how-it-works__sticker position-relative d-flex justify-center">
          До речі, номінувати можна скільки завгодно колег, але кожного не більше 5 разів <span class="how-it-works__sticker-icon position-absolute d-block">😏</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowItWorks'
}
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
.how-it-works {
  flex-direction: column;
  padding-bottom: sm(175);
  @include _1024 {
    flex-direction: row;
    padding-bottom: sl(276);
  }
  @include _1920 {
    padding-bottom: 276px;
  }
  &__sticker {
    font-size: sm(16);
    padding: sm(16) sm(24);
    background: $white;
    box-shadow: 0px 6px 12px rgba(84, 101, 101, 0.12);
    border-radius: sm(8);
    width: 100%;
    @include _1024 {
      border-radius: sl(8);
      width: sl(636);
      padding: sl(24) sl(32);
      font-size: sl(24);
    }
    @include _1920 {
      border-radius: 8px;
      width: 636px;
      font-size: 24px;
      padding: 24px 32px;
    }
    &-icon {
      width: sm(40);
      height: sm(60);
      font-size: sm(40);
      right: sm(26);
      bottom: sm(-36);
      transform: rotate(13.64deg);
      text-shadow: 3px 4px 10px rgba(84, 101, 102, 0.25);
      @include _1024 {
        width: sl(56);
        height: sl(84);
        font-size: sl(56);
        right: sl(34);
        bottom: sl(-40);
      }
      @include _1920 {
        width: 56px;
        height: 84px;
        font-size: 56px;
        right: 34px;
        bottom: -40px;
      }
    }
  }
  &__img {
    width: sm(218.74);
    height: sm(304.3);
    margin-left: sm(35.42);
    object-fit: contain;
    object-position: center;
    @include _1024 {
      margin-left: sl(24);
      margin-top: sl(152);
      width: sl(430.98);
      height: sl(596);
    }
    @include _1920 {
      margin-top: 152px;
      margin-left: 24px;
      width: 430.98px;
      height: 596px;
    }
  }
  &__text-wrapper {
    @include _1024 {
      width: sl(880);
      margin-left: auto;
    }
    @include _1920 {
      width: 880px;
    }
  }
  &__title {
    font-size: sm(24);
    padding-top: sm(57);
    @include _1024 {
      font-size: sl(48);
      padding-top: 0;
    }
    @include _1920 {
      font-size: 48px;
    }
  }
  &__list {
    counter-reset: counter;
    list-style: none;
    padding: sm(38) 0 sm(32);
    margin: 0;
    @include _1024 {
      padding: sl(72) 0 sl(78);
    }
    @include _1920 {
      padding: 72px 0 78px;
    }
    &-item {
      counter-increment: counter;
      padding: sm(52) 0 0;
      margin: 0;
      font-size: sm(16);
      @include _1024 {
        padding: 0 0 0 sl(80);
        font-size: sl(28);
      }
      @include _1920 {
        padding: 0 0 0 80px;
        font-size: 28px;
      }
      & + & {
        margin-top: sm(32);
        @include _1024 {
          margin-top: sl(40);
        }
        @include _1920 {
          margin-top: 40px;
        }
      }
      &:before {
        content: counter(counter);
        font-size: sm(16);
        width: sm(40);
        height: sm(40);
        border-radius: 50%;
        background: $success;
        border: 2px solid $white;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: $white;
        position: absolute;
        top: 0;
        left: 0;
        @include _1024 {
          width: sl(56);
          height: sl(56);
          font-size: sl(24);
        }
        @include _1920 {
          width: 56px;
          height: 56px;
          font-size: 24px;
        }
      }
    }
  }
}
</style>
